module.exports = __webpack_public_path__ + "officialStatic/img/sw-detailList11.af7d8fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw-detailList11.png
// module id = Hp5t
// module chunks = 0